import * as React from 'react';

import { SVGProps } from '../../types';

export const IconXSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    focusable="false"
    fill="currentColor"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M13.53 5.53a.75.75 0 00-1.06-1.06L9 7.94 5.53 4.47a.75.75 0 00-1.06 1.06L7.94 9l-3.47 3.47a.75.75 0 001.06 1.06L9 10.06l3.47 3.47a.75.75 0 001.06-1.06L10.06 9l3.47-3.47z"
    />
  </svg>
);
